import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import StatsAndStandingsHomeNavigation from './StatsAndStandingsHomeNavigation'
import SelectLeague from '../UIElements/SelectLeague'
import './StatsAndStandingsHome.css'
import ListOfCustomers from './ListOfCustomers'
import useInApp from '../../hooks/useInApp'
import useEntitlement from '../../hooks/useEntitlement'
import { getOrCreateIapUserId } from './iapUserId'

const StatsAndStandingsHome = () => {
	const navigate = useNavigate()

	const { hasIap } = useInApp()

	const userId = getOrCreateIapUserId()
	const entitlement = useEntitlement(hasIap, userId)

	const { pathname } = useLocation()
	const atHome = pathname === '/' || pathname === ''

	const showCustomers = atHome && hasIap && entitlement === 'active'

	return (
		<div>
			<StatsAndStandingsHomeNavigation />
			<SelectLeague />

			{showCustomers && (
				<div className='stt-home-content'>
					<div className='stt-player-history'>
						<div className='stt-player-history__content'>
							<div className='stt-player-history__heading'>
								<span className='stt-player-history__badge'>NEW!</span>

								<h2>PLAYER HISTORY</h2>
							</div>

							<p>
								View career stats from ALL leagues and tournaments in one place.
							</p>

							<button
								type='button'
								className='stt-player-history__button'
								onClick={() => navigate('/player-history-search')}
							>
								Search Player History
								<span aria-hidden='true'>❯</span>
							</button>
						</div>
					</div>

					<h2 className='stt-partner-heading'>Our Partner Organizations:</h2>

					<ListOfCustomers />
				</div>
			)}
		</div>
	)
}

export default StatsAndStandingsHome
